import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Tags from '../Tags';

export interface IBlogRollPostItemProps extends IBaseElementProps {
	/**
	 * Post Image
	 */
	image?: IImage;
	/**
	 * Post Tags
	 */
	tags?: ILink[];
	/**
	 * Post Description
	 */
	description?: string;
	/**
	 * Post Link
	 */
	link?: ILink;
	/**
	 * Post CTA Button / Link
	 */
	cta?: ILink;
}

// TODO: Component currently exposed for Design Review - Remove Block decorator prior to content entry if Blog Roll is integrated with Page Templates, or else B/E will need to implement dynamic selection of posts for use within this component.

/**
 * Blog Roll Post Item
 * @block
 * @requiresHooks
 * @icon media-document
 */
const BlogRollPostItem: React.FC<IBlogRollPostItemProps> = ({
	className,
	classNames = [],
	image,
	tags = [],
	description,
	link,
	cta,
}) => (
	<div className={className || cn('blogroll-post-item', ...classNames)}>
		{image && (
			<a
				className="blogroll-post-item__image-container"
				href={link && link.href}
			>
				<Image {...image} className="blogroll-post-item__image" />
			</a>
		)}
		<div className="blogroll-post-item__content">
			{link && <Button {...link} className="blogroll-post-item__link" />}

			{tags.length > 0 && (
				<Tags tags={tags} className="blogroll-post-item__tags" />
			)}
			{description && (
				<div className="blogroll-post-item__description">
					{description}
				</div>
			)}
			{cta && <Button {...cta} className="btn btn-sm btn-logo-blue" />}
		</div>
	</div>
);

export default BlogRollPostItem;
